module.exports = __webpack_public_path__ + "img/SL7_4600-Bearbeitet.b21a6961.jpg";